import { render } from "./SideBarDesktopSettings.vue?vue&type=template&id=f707b9d4"
import script from "./SideBarDesktopSettings.vue?vue&type=script&lang=js"
export * from "./SideBarDesktopSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__